import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {makeGetAccount} from '../../../store/data/accounts/accountsSelectors';
import {AccountPopover} from './accountPopover';

/*
 * Props.
 */

interface AccountPopoverContainerProps {
  accountId: number;
}

/*
 * Selectors.
 */

function getAccountId(_state: AppState, props: AccountPopoverContainerProps) {
  return props.accountId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AccountPopoverContainerProps>()(() => ({
  account: makeGetAccount(getAccountId),
}));

export const AccountPopoverContainer = connect(mapStateToProps)(AccountPopover);
